import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import emailService from "../services/emailService";
import EmailListView from "../components/EmailListView";
import "../css/EmailDetails.css";

const EmailDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [email, setEmail] = useState(null);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchEmail = async () => {
            console.log(`📧 EmailDetails: Fetching email with ID: ${id}`);
            try {
                const data = await emailService.getEmailById(id);
                console.log(`📧 EmailDetails: Email data received:`, data);
                setEmail(data);
            } catch (err) {
                console.error(`❌ EmailDetails: Failed to fetch email details:`, err);
                setError("Failed to fetch email details.");
            }
        };
        fetchEmail();
    }, [id]);

    if (error) {
        return (
            <div className="email-details-page">
                <div className="email-details-content">
                    <div className="email-details-error">
                        <div className="email-details-error-icon">❌</div>
                        <h3>Error Loading Email</h3>
                        <p>{error}</p>
                    </div>
                </div>
            </div>
        );
    }

    if (!email) {
        return (
            <div className="email-details-page">
                <div className="email-details-content">
                    <div className="email-details-loading">
                        <div className="email-details-spinner"></div>
                        <p>Loading email...</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="email-details-page">
            <div className="email-details-content">
                <button
                    className="email-details-back"
                    onClick={() => navigate(-1)}
                >
                    ← Back
                </button>
                <div className="email-details-header">
                    <h1 className="email-details-title">Email Details</h1>
                </div>
                <EmailListView
                    title={null}
                    emails={[email]}
                    onMarkAsReviewed={() => {}}
                    onAddComment={() => {}}
                    onUpdateComment={() => {}}
                    currentPage={1}
                    totalPages={1}
                    onPageChange={() => {}}
                    defaultExpanded={true}
                />
            </div>
        </div>
    );
};

export default EmailDetails;
